import Page404 from './Components/Page404.jsx';

export default Page404;
